(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("sjcl"), require("aws-sdk"), require("jsbn"));
	else if(typeof define === 'function' && define.amd)
		define(["sjcl", "aws-sdk", "jsbn"], factory);
	else if(typeof exports === 'object')
		exports["AmazonCognitoIdentity"] = factory(require("sjcl"), require("aws-sdk"), require("jsbn"));
	else
		root["AmazonCognitoIdentity"] = factory(root["sjcl"], root["AWSCognito"], root["window"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_1__, __WEBPACK_EXTERNAL_MODULE_10__, __WEBPACK_EXTERNAL_MODULE_11__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _src = __webpack_require__(14);
	
	Object.keys(_src).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _src[key];
	    }
	  });
	});
	
	var _awsSdk = __webpack_require__(10);
	
	var enhancements = _interopRequireWildcard(_src);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	Object.keys(enhancements).forEach(function (key) {
	  _awsSdk.CognitoIdentityServiceProvider[key] = enhancements[key];
	});

/***/ },
/* 1 */
/***/ function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_1__;

/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /*!
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Copyright 2016 Amazon.com,
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Inc. or its affiliates. All Rights Reserved.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Licensed under the Amazon Software License (the "License").
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * You may not use this file except in compliance with the
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * License. A copy of the License is located at
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *     http://aws.amazon.com/asl/
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * or in the "license" file accompanying this file. This file is
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * CONDITIONS OF ANY KIND, express or implied. See the License
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * for the specific language governing permissions and
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * limitations under the License.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */
	
	var _sjcl = __webpack_require__(1);
	
	var sjcl = _interopRequireWildcard(_sjcl);
	
	var _jsbn = __webpack_require__(11);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var initN = 'FFFFFFFFFFFFFFFFC90FDAA22168C234C4C6628B80DC1CD1' + '29024E088A67CC74020BBEA63B139B22514A08798E3404DD' + 'EF9519B3CD3A431B302B0A6DF25F14374FE1356D6D51C245' + 'E485B576625E7EC6F44C42E9A637ED6B0BFF5CB6F406B7ED' + 'EE386BFB5A899FA5AE9F24117C4B1FE649286651ECE45B3D' + 'C2007CB8A163BF0598DA48361C55D39A69163FA8FD24CF5F' + '83655D23DCA3AD961C62F356208552BB9ED529077096966D' + '670C354E4ABC9804F1746C08CA18217C32905E462E36CE3B' + 'E39E772C180E86039B2783A2EC07A28FB5C55DF06F4C52C9' + 'DE2BCBF6955817183995497CEA956AE515D2261898FA0510' + '15728E5A8AAAC42DAD33170D04507A33A85521ABDF1CBA64' + 'ECFB850458DBEF0A8AEA71575D060C7DB3970F85A6E1E4C7' + 'ABF5AE8CDB0933D71E8C94E04A25619DCEE3D2261AD2EE6B' + 'F12FFA06D98A0864D87602733EC86A64521F2B18177B200C' + 'BBE117577A615D6C770988C0BAD946E208E24FA074E5AB31' + '43DB5BFCE0FD108E4B82D120A93AD2CAFFFFFFFFFFFFFFFF';
	
	/** @class */
	
	var AuthenticationHelper = function () {
	  /**
	   * Constructs a new AuthenticationHelper object
	   * @param {string} PoolName Cognito user pool name.
	   * @param {int} paranoia Random number generation paranoia level.
	   */
	  function AuthenticationHelper(PoolName, paranoia) {
	    _classCallCheck(this, AuthenticationHelper);
	
	    this.N = new _jsbn.BigInteger(initN, 16);
	    this.g = new _jsbn.BigInteger('2');
	    this.k = new _jsbn.BigInteger(this.hexHash('00' + this.N.toString(16) + '0' + this.g.toString(16)), 16);
	
	    this.paranoia = paranoia;
	
	    this.smallAValue = this.generateRandomSmallA();
	    this.largeAValue = this.calculateA(this.smallAValue);
	
	    this.infoBits = sjcl.codec.utf8String.toBits('Caldera Derived Key');
	
	    this.poolName = PoolName;
	  }
	
	  /**
	   * @returns {BigInteger} small A, a random number
	   */
	
	
	  _createClass(AuthenticationHelper, [{
	    key: 'getSmallAValue',
	    value: function getSmallAValue() {
	      return this.smallAValue;
	    }
	
	    /**
	     * @returns {BigInteger} large A, a value generated from small A
	     */
	
	  }, {
	    key: 'getLargeAValue',
	    value: function getLargeAValue() {
	      return this.largeAValue;
	    }
	
	    /**
	     * helper function to generate a random big integer
	     * @returns {BigInteger} a random value.
	     * @private
	     */
	
	  }, {
	    key: 'generateRandomSmallA',
	    value: function generateRandomSmallA() {
	      var words = sjcl.random.randomWords(32, this.paranoia);
	      var hexRandom = sjcl.codec.hex.fromBits(words);
	
	      var randomBigInt = new _jsbn.BigInteger(hexRandom, 16);
	      var smallABigInt = randomBigInt.mod(this.N);
	
	      return smallABigInt;
	    }
	
	    /**
	     * helper function to generate a random string
	     * @returns {string} a random value.
	     * @private
	     */
	
	  }, {
	    key: 'generateRandomString',
	    value: function generateRandomString() {
	      var words = sjcl.random.randomWords(10, this.paranoia);
	      var stringRandom = sjcl.codec.base64.fromBits(words);
	
	      return stringRandom;
	    }
	
	    /**
	     * @returns {string} Generated random value included in password hash.
	     */
	
	  }, {
	    key: 'getRandomPassword',
	    value: function getRandomPassword() {
	      return this.randomPassword;
	    }
	
	    /**
	     * @returns {string} Generated random value included in devices hash.
	     */
	
	  }, {
	    key: 'getSaltDevices',
	    value: function getSaltDevices() {
	      return this.SaltToHashDevices;
	    }
	
	    /**
	     * @returns {string} Value used to verify devices.
	     */
	
	  }, {
	    key: 'getVerifierDevices',
	    value: function getVerifierDevices() {
	      return this.verifierDevices;
	    }
	
	    /**
	     * Generate salts and compute verifier.
	     * @param {string} deviceGroupKey Devices to generate verifier for.
	     * @param {string} username User to generate verifier for.
	     * @returns {void}
	     */
	
	  }, {
	    key: 'generateHashDevice',
	    value: function generateHashDevice(deviceGroupKey, username) {
	      this.randomPassword = this.generateRandomString();
	      var combinedString = '' + deviceGroupKey + username + ':' + this.randomPassword;
	      var hashedString = this.hash(combinedString);
	
	      var words = sjcl.random.randomWords(4, this.paranoia);
	      var hexRandom = sjcl.codec.hex.fromBits(words);
	      var saltDevices = new _jsbn.BigInteger(hexRandom, 16);
	      var firstCharSalt = saltDevices.toString(16)[0];
	      this.SaltToHashDevices = saltDevices.toString(16);
	
	      if (saltDevices.toString(16).length % 2 === 1) {
	        this.SaltToHashDevices = '0' + this.SaltToHashDevices;
	      } else if ('89ABCDEFabcdef'.indexOf(firstCharSalt) !== -1) {
	        this.SaltToHashDevices = '00' + this.SaltToHashDevices;
	      }
	      var verifierDevicesNotPadded = this.g.modPow(new _jsbn.BigInteger(this.hexHash(this.SaltToHashDevices + hashedString), 16), this.N);
	
	      var firstCharVerifierDevices = verifierDevicesNotPadded.toString(16)[0];
	      this.verifierDevices = verifierDevicesNotPadded.toString(16);
	
	      if (verifierDevicesNotPadded.toString(16).length % 2 === 1) {
	        this.verifierDevices = '0' + this.verifierDevices;
	      } else if ('89ABCDEFabcdef'.indexOf(firstCharVerifierDevices) !== -1) {
	        this.verifierDevices = '00' + this.verifierDevices;
	      }
	    }
	
	    /**
	     * Calculate the client's public value A = g^a%N
	     * with the generated random number a
	     * @param {BigInteger} a Randomly generated small A.
	     * @returns {BigInteger} Computed large A.
	     * @private
	     */
	
	  }, {
	    key: 'calculateA',
	    value: function calculateA(a) {
	      var A = this.g.modPow(a, this.N);
	
	      if (A.mod(this.N).toString() === '0') {
	        throw new Error('Illegal paramater. A mod N cannot be 0.');
	      }
	      return A;
	    }
	
	    /**
	     * Calculate the client's value U which is the hash of A and B
	     * @param {BigInteger} A Large A value.
	     * @param {BigInteger} B Server B value.
	     * @returns {BigInteger} Computed U value.
	     * @private
	     */
	
	  }, {
	    key: 'calculateU',
	    value: function calculateU(A, B) {
	      var firstCharA = A.toString(16)[0];
	      var firstCharB = B.toString(16)[0];
	      var AToHash = A.toString(16);
	      var BToHash = B.toString(16);
	
	      if (A.toString(16).length % 2 === 1) {
	        AToHash = '0' + AToHash;
	      } else if ('89ABCDEFabcdef'.indexOf(firstCharA) !== -1) {
	        AToHash = '00' + AToHash;
	      }
	
	      if (B.toString(16).length % 2 === 1) {
	        BToHash = '0' + BToHash;
	      } else if ('89ABCDEFabcdef'.indexOf(firstCharB) !== -1) {
	        BToHash = '00' + BToHash;
	      }
	
	      this.UHexHash = this.hexHash(AToHash + BToHash);
	      var finalU = new _jsbn.BigInteger(this.UHexHash, 16);
	
	      return finalU;
	    }
	
	    /**
	     * Calculate a hash from a bitArray
	     * @param {sjcl.bitArray} bitArray Value to hash.
	     * @returns {String} Hex-encoded hash.
	     * @private
	     */
	
	  }, {
	    key: 'hash',
	    value: function hash(bitArray) {
	      var hashHex = sjcl.codec.hex.fromBits(sjcl.hash.sha256.hash(bitArray));
	      return new Array(64 - hashHex.length).join('0') + hashHex;
	    }
	
	    /**
	     * Calculate a hash from a hex string
	     * @param {String} hexStr Value to hash.
	     * @returns {String} Hex-encoded hash.
	     * @private
	     */
	
	  }, {
	    key: 'hexHash',
	    value: function hexHash(hexStr) {
	      var hashHex = sjcl.codec.hex.fromBits(sjcl.hash.sha256.hash(sjcl.codec.hex.toBits(hexStr)));
	      return new Array(64 - hashHex.length).join('0') + hashHex;
	    }
	
	    /**
	     * Standard hkdf algorithm
	     * @param {sjcl.bitArray} ikm Input key material.
	     * @param {sjcl.bitArray} salt Salt value.
	     * @returns {sjcl.bitArray} Strong key material.
	     * @private
	     */
	
	  }, {
	    key: 'computehkdf',
	    value: function computehkdf(ikm, salt) {
	      var mac = new sjcl.misc.hmac(salt, sjcl.hash.sha256);
	      mac.update(ikm);
	      var prk = mac.digest();
	      var hmac = new sjcl.misc.hmac(prk, sjcl.hash.sha256);
	      var infoBitsUpdate = sjcl.bitArray.concat(this.infoBits, sjcl.codec.utf8String.toBits(String.fromCharCode(1)));
	      hmac.update(infoBitsUpdate);
	
	      return sjcl.bitArray.clamp(hmac.digest(), 128);
	    }
	
	    /**
	     * Calculates the final hkdf based on computed S value, and computed U value and the key
	     * @param {String} username Username.
	     * @param {String} password Password.
	     * @param {BigInteger} serverBValue Server B value.
	     * @param {BigInteger} salt Generated salt.
	     * @returns {sjcl.bitArray} Computed HKDF value.
	     */
	
	  }, {
	    key: 'getPasswordAuthenticationKey',
	    value: function getPasswordAuthenticationKey(username, password, serverBValue, salt) {
	      if (serverBValue.mod(this.N).equals(new _jsbn.BigInteger('0', 16))) {
	        throw new Error('B cannot be zero.');
	      }
	
	      this.UValue = this.calculateU(this.largeAValue, serverBValue);
	
	      if (this.UValue.equals(new _jsbn.BigInteger('0', 16))) {
	        throw new Error('U cannot be zero.');
	      }
	
	      var usernamePassword = '' + this.poolName + username + ':' + password;
	      var usernamePasswordHash = this.hash(usernamePassword);
	
	      var firstCharSalt = salt.toString(16)[0];
	      var SaltToHash = salt.toString(16);
	
	      if (salt.toString(16).length % 2 === 1) {
	        SaltToHash = '0' + SaltToHash;
	      } else if ('89ABCDEFabcdef'.indexOf(firstCharSalt) !== -1) {
	        SaltToHash = '00' + SaltToHash;
	      }
	
	      var xValue = new _jsbn.BigInteger(this.hexHash(SaltToHash + usernamePasswordHash), 16);
	
	      var gModPowXN = this.g.modPow(xValue, this.N);
	      var intValue2 = serverBValue.subtract(this.k.multiply(gModPowXN));
	      var sValue = intValue2.modPow(this.smallAValue.add(this.UValue.multiply(xValue)), this.N).mod(this.N);
	
	      var SToHash = sValue.toString(16);
	      var firstCharS = sValue.toString(16)[0];
	
	      if (sValue.toString(16).length % 2 === 1) {
	        SToHash = '0' + SToHash;
	      } else if ('89ABCDEFabcdef'.indexOf(firstCharS) !== -1) {
	        SToHash = '00' + SToHash;
	      }
	
	      var UValueToHash = this.UHexHash;
	      var firstCharU = this.UHexHash[0];
	
	      if (this.UHexHash.length % 2 === 1) {
	        UValueToHash = '0' + UValueToHash;
	      } else if (this.UHexHash.length % 2 === 0 && '89ABCDEFabcdef'.indexOf(firstCharU) !== -1) {
	        UValueToHash = '00' + UValueToHash;
	      }
	
	      var hkdf = this.computehkdf(sjcl.codec.hex.toBits(SToHash), sjcl.codec.hex.toBits(UValueToHash));
	
	      return hkdf;
	    }
	  }]);
	
	  return AuthenticationHelper;
	}();
	
	exports.default = AuthenticationHelper;

/***/ },
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /*
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Copyright 2016 Amazon.com,
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Inc. or its affiliates. All Rights Reserved.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Licensed under the Amazon Software License (the "License").
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * You may not use this file except in compliance with the
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * License. A copy of the License is located at
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *     http://aws.amazon.com/asl/
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * or in the "license" file accompanying this file. This file is
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * CONDITIONS OF ANY KIND, express or implied. See the License
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * for the specific language governing permissions and
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * limitations under the License.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */
	
	var _sjcl = __webpack_require__(1);
	
	var sjcl = _interopRequireWildcard(_sjcl);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/** @class */
	var CognitoAccessToken = function () {
	  /**
	   * Constructs a new CognitoAccessToken object
	   * @param {string=} AccessToken The JWT access token.
	   */
	  function CognitoAccessToken() {
	    var _ref = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	    var AccessToken = _ref.AccessToken;
	
	    _classCallCheck(this, CognitoAccessToken);
	
	    // Assign object
	    this.jwtToken = AccessToken || '';
	  }
	
	  /**
	   * @returns {string} the record's token.
	   */
	
	
	  _createClass(CognitoAccessToken, [{
	    key: 'getJwtToken',
	    value: function getJwtToken() {
	      return this.jwtToken;
	    }
	
	    /**
	     * @returns {int} the token's expiration (exp member).
	     */
	
	  }, {
	    key: 'getExpiration',
	    value: function getExpiration() {
	      var payload = this.jwtToken.split('.')[1];
	      var expiration = JSON.parse(sjcl.codec.utf8String.fromBits(sjcl.codec.base64url.toBits(payload)));
	      return expiration.exp;
	    }
	  }]);
	
	  return CognitoAccessToken;
	}();
	
	exports.default = CognitoAccessToken;

/***/ },
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /*!
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Copyright 2016 Amazon.com,
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Inc. or its affiliates. All Rights Reserved.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Licensed under the Amazon Software License (the "License").
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * You may not use this file except in compliance with the
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * License. A copy of the License is located at
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *     http://aws.amazon.com/asl/
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * or in the "license" file accompanying this file. This file is
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * CONDITIONS OF ANY KIND, express or implied. See the License
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * for the specific language governing permissions and
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * limitations under the License.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */
	
	var _sjcl = __webpack_require__(1);
	
	var sjcl = _interopRequireWildcard(_sjcl);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/** @class */
	var CognitoIdToken = function () {
	  /**
	   * Constructs a new CognitoIdToken object
	   * @param {string=} IdToken The JWT Id token
	   */
	  function CognitoIdToken() {
	    var _ref = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	    var IdToken = _ref.IdToken;
	
	    _classCallCheck(this, CognitoIdToken);
	
	    // Assign object
	    this.jwtToken = IdToken || '';
	  }
	
	  /**
	   * @returns {string} the record's token.
	   */
	
	
	  _createClass(CognitoIdToken, [{
	    key: 'getJwtToken',
	    value: function getJwtToken() {
	      return this.jwtToken;
	    }
	
	    /**
	     * @returns {int} the token's expiration (exp member).
	     */
	
	  }, {
	    key: 'getExpiration',
	    value: function getExpiration() {
	      var payload = this.jwtToken.split('.')[1];
	      var expiration = JSON.parse(sjcl.codec.utf8String.fromBits(sjcl.codec.base64url.toBits(payload)));
	      return expiration.exp;
	    }
	  }]);
	
	  return CognitoIdToken;
	}();
	
	exports.default = CognitoIdToken;

/***/ },
/* 5 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/*!
	 * Copyright 2016 Amazon.com,
	 * Inc. or its affiliates. All Rights Reserved.
	 *
	 * Licensed under the Amazon Software License (the "License").
	 * You may not use this file except in compliance with the
	 * License. A copy of the License is located at
	 *
	 *     http://aws.amazon.com/asl/
	 *
	 * or in the "license" file accompanying this file. This file is
	 * distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
	 * CONDITIONS OF ANY KIND, express or implied. See the License
	 * for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	/** @class */
	var CognitoRefreshToken = function () {
	  /**
	   * Constructs a new CognitoRefreshToken object
	   * @param {string=} RefreshToken The JWT refresh token.
	   */
	  function CognitoRefreshToken() {
	    var _ref = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	    var RefreshToken = _ref.RefreshToken;
	
	    _classCallCheck(this, CognitoRefreshToken);
	
	    // Assign object
	    this.token = RefreshToken || '';
	  }
	
	  /**
	   * @returns {string} the record's token.
	   */
	
	
	  _createClass(CognitoRefreshToken, [{
	    key: 'getToken',
	    value: function getToken() {
	      return this.token;
	    }
	  }]);
	
	  return CognitoRefreshToken;
	}();
	
	exports.default = CognitoRefreshToken;

/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /*!
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Copyright 2016 Amazon.com,
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Inc. or its affiliates. All Rights Reserved.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Licensed under the Amazon Software License (the "License").
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * You may not use this file except in compliance with the
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * License. A copy of the License is located at
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *     http://aws.amazon.com/asl/
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * or in the "license" file accompanying this file. This file is
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * CONDITIONS OF ANY KIND, express or implied. See the License
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * for the specific language governing permissions and
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * limitations under the License.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */
	
	var _sjcl = __webpack_require__(1);
	
	var sjcl = _interopRequireWildcard(_sjcl);
	
	var _jsbn = __webpack_require__(11);
	
	var _AuthenticationHelper = __webpack_require__(2);
	
	var _AuthenticationHelper2 = _interopRequireDefault(_AuthenticationHelper);
	
	var _CognitoAccessToken = __webpack_require__(3);
	
	var _CognitoAccessToken2 = _interopRequireDefault(_CognitoAccessToken);
	
	var _CognitoIdToken = __webpack_require__(4);
	
	var _CognitoIdToken2 = _interopRequireDefault(_CognitoIdToken);
	
	var _CognitoRefreshToken = __webpack_require__(5);
	
	var _CognitoRefreshToken2 = _interopRequireDefault(_CognitoRefreshToken);
	
	var _CognitoUserSession = __webpack_require__(8);
	
	var _CognitoUserSession2 = _interopRequireDefault(_CognitoUserSession);
	
	var _DateHelper = __webpack_require__(9);
	
	var _DateHelper2 = _interopRequireDefault(_DateHelper);
	
	var _CognitoUserAttribute = __webpack_require__(7);
	
	var _CognitoUserAttribute2 = _interopRequireDefault(_CognitoUserAttribute);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * @callback nodeCallback
	 * @template T result
	 * @param {*} err The operation failure reason, or null.
	 * @param {T} result The operation result.
	 */
	
	/**
	 * @callback onFailure
	 * @param {*} err Failure reason.
	 */
	
	/**
	 * @callback onSuccess
	 * @template T result
	 * @param {T} result The operation result.
	 */
	
	/**
	 * @callback mfaRequired
	 * @param {*} details MFA challenge details.
	 */
	
	/**
	 * @callback customChallenge
	 * @param {*} details Custom challenge details.
	 */
	
	/**
	 * @callback inputVerificationCode
	 * @param {*} data Server response.
	 */
	
	/**
	 * @callback authSuccess
	 * @param {CognitoUserSession} session The new session.
	 * @param {bool=} userConfirmationNecessary User must be confirmed.
	 */
	
	/** @class */
	var CognitoUser = function () {
	  /**
	   * Constructs a new CognitoUser object
	   * @param {object} data Creation options
	   * @param {string} data.Username The user's username.
	   * @param {CognitoUserPool} data.Pool Pool containing the user.
	   */
	  function CognitoUser(data) {
	    _classCallCheck(this, CognitoUser);
	
	    if (data == null || data.Username == null || data.Pool == null) {
	      throw new Error('Username and pool information are required.');
	    }
	
	    this.username = data.Username || '';
	    this.pool = data.Pool;
	    this.Session = null;
	
	    this.client = data.Pool.client;
	
	    this.signInUserSession = null;
	    this.authenticationFlowType = 'USER_SRP_AUTH';
	  }
	
	  /**
	   * @returns {CognitoUserSession} the current session for this user
	   */
	
	
	  _createClass(CognitoUser, [{
	    key: 'getSignInUserSession',
	    value: function getSignInUserSession() {
	      return this.signInUserSession;
	    }
	
	    /**
	     * @returns {string} the user's username
	     */
	
	  }, {
	    key: 'getUsername',
	    value: function getUsername() {
	      return this.username;
	    }
	
	    /**
	     * @returns {String} the authentication flow type
	     */
	
	  }, {
	    key: 'getAuthenticationFlowType',
	    value: function getAuthenticationFlowType() {
	      return this.authenticationFlowType;
	    }
	
	    /**
	     * sets authentication flow type
	     * @param {string} authenticationFlowType New value.
	     * @returns {void}
	     */
	
	  }, {
	    key: 'setAuthenticationFlowType',
	    value: function setAuthenticationFlowType(authenticationFlowType) {
	      this.authenticationFlowType = authenticationFlowType;
	    }
	
	    /**
	     * This is used for authenticating the user. it calls the AuthenticationHelper for SRP related
	     * stuff
	     * @param {AuthenticationDetails} authDetails Contains the authentication data
	     * @param {object} callback Result callback map.
	     * @param {onFailure} callback.onFailure Called on any error.
	     * @param {mfaRequired} callback.mfaRequired MFA code required to continue.
	     * @param {customChallenge} callback.customChallenge
	     *    Custom challenge response required to continue.
	     * @param {authSuccess} callback.onSuccess Called on success with the new session.
	     * @returns {void}
	     */
	
	  }, {
	    key: 'authenticateUser',
	    value: function authenticateUser(authDetails, callback) {
	      var _this = this;
	
	      var authenticationHelper = new _AuthenticationHelper2.default(this.pool.getUserPoolId().split('_')[1], this.pool.getParanoia());
	      var dateHelper = new _DateHelper2.default();
	
	      var serverBValue = void 0;
	      var salt = void 0;
	      var authParameters = {};
	
	      if (this.deviceKey != null) {
	        authParameters.DEVICE_KEY = this.deviceKey;
	      }
	
	      authParameters.USERNAME = this.username;
	      authParameters.SRP_A = authenticationHelper.getLargeAValue().toString(16);
	
	      if (this.authenticationFlowType === 'CUSTOM_AUTH') {
	        authParameters.CHALLENGE_NAME = 'SRP_A';
	      }
	
	      this.client.makeUnauthenticatedRequest('initiateAuth', {
	        AuthFlow: this.authenticationFlowType,
	        ClientId: this.pool.getClientId(),
	        AuthParameters: authParameters,
	        ClientMetadata: authDetails.getValidationData()
	      }, function (err, data) {
	        if (err) {
	          return callback.onFailure(err);
	        }
	
	        var challengeParameters = data.ChallengeParameters;
	
	        _this.username = challengeParameters.USER_ID_FOR_SRP;
	        serverBValue = new _jsbn.BigInteger(challengeParameters.SRP_B, 16);
	        salt = new _jsbn.BigInteger(challengeParameters.SALT, 16);
	        _this.getCachedDeviceKeyAndPassword();
	
	        var hkdf = authenticationHelper.getPasswordAuthenticationKey(_this.username, authDetails.getPassword(), serverBValue, salt);
	        var secretBlockBits = sjcl.codec.base64.toBits(challengeParameters.SECRET_BLOCK);
	
	        var mac = new sjcl.misc.hmac(hkdf, sjcl.hash.sha256);
	        mac.update(sjcl.codec.utf8String.toBits(_this.pool.getUserPoolId().split('_')[1]));
	        mac.update(sjcl.codec.utf8String.toBits(_this.username));
	        mac.update(secretBlockBits);
	        var dateNow = dateHelper.getNowString();
	        mac.update(sjcl.codec.utf8String.toBits(dateNow));
	        var signature = mac.digest();
	        var signatureString = sjcl.codec.base64.fromBits(signature);
	
	        var challengeResponses = {};
	
	        challengeResponses.USERNAME = _this.username;
	        challengeResponses.PASSWORD_CLAIM_SECRET_BLOCK = challengeParameters.SECRET_BLOCK;
	        challengeResponses.TIMESTAMP = dateNow;
	        challengeResponses.PASSWORD_CLAIM_SIGNATURE = signatureString;
	
	        if (_this.deviceKey != null) {
	          challengeResponses.DEVICE_KEY = _this.deviceKey;
	        }
	
	        _this.client.makeUnauthenticatedRequest('respondToAuthChallenge', {
	          ChallengeName: 'PASSWORD_VERIFIER',
	          ClientId: _this.pool.getClientId(),
	          ChallengeResponses: challengeResponses,
	          Session: data.Session
	        }, function (errAuthenticate, dataAuthenticate) {
	          if (errAuthenticate) {
	            return callback.onFailure(errAuthenticate);
	          }
	
	          var challengeName = dataAuthenticate.ChallengeName;
	          if (challengeName === 'SMS_MFA') {
	            _this.Session = dataAuthenticate.Session;
	            return callback.mfaRequired(challengeName);
	          }
	
	          if (challengeName === 'CUSTOM_CHALLENGE') {
	            _this.Session = dataAuthenticate.Session;
	            return callback.customChallenge(dataAuthenticate.ChallengeParameters);
	          }
	
	          if (challengeName === 'DEVICE_SRP_AUTH') {
	            _this.getDeviceResponse(callback);
	            return undefined;
	          }
	
	          _this.signInUserSession = _this.getCognitoUserSession(dataAuthenticate.AuthenticationResult);
	          _this.cacheTokens();
	
	          var newDeviceMetadata = dataAuthenticate.AuthenticationResult.NewDeviceMetadata;
	          if (newDeviceMetadata == null) {
	            return callback.onSuccess(_this.signInUserSession);
	          }
	
	          authenticationHelper.generateHashDevice(dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceGroupKey, dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceKey);
	
	          var deviceSecretVerifierConfig = {
	            Salt: sjcl.codec.base64.fromBits(sjcl.codec.hex.toBits(authenticationHelper.getSaltDevices().toString(16))),
	            PasswordVerifier: sjcl.codec.base64.fromBits(sjcl.codec.hex.toBits(authenticationHelper.getVerifierDevices().toString(16)))
	          };
	
	          _this.verifierDevices = sjcl.codec.base64.fromBits(authenticationHelper.getVerifierDevices());
	          _this.deviceGroupKey = newDeviceMetadata.DeviceGroupKey;
	          _this.randomPassword = authenticationHelper.getRandomPassword();
	
	          _this.client.makeUnauthenticatedRequest('confirmDevice', {
	            DeviceKey: newDeviceMetadata.DeviceKey,
	            AccessToken: _this.signInUserSession.getAccessToken().getJwtToken(),
	            DeviceSecretVerifierConfig: deviceSecretVerifierConfig,
	            DeviceName: navigator.userAgent
	          }, function (errConfirm, dataConfirm) {
	            if (errConfirm) {
	              return callback.onFailure(errConfirm);
	            }
	            _this.deviceKey = dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceKey;
	            _this.cacheDeviceKeyAndPassword();
	            if (dataConfirm.UserConfirmationNecessary === true) {
	              return callback.onSuccess(_this.signInUserSession, dataConfirm.UserConfirmationNecessary);
	            }
	            return callback.onSuccess(_this.signInUserSession);
	          });
	          return undefined;
	        });
	        return undefined;
	      });
	    }
	
	    /**
	     * This is used to get a session using device authentication. It is called at the end of user
	     * authentication
	     *
	     * @param {object} callback Result callback map.
	     * @param {onFailure} callback.onFailure Called on any error.
	     * @param {authSuccess} callback.onSuccess Called on success with the new session.
	     * @returns {void}
	     * @private
	     */
	
	  }, {
	    key: 'getDeviceResponse',
	    value: function getDeviceResponse(callback) {
	      var _this2 = this;
	
	      var authenticationHelper = new _AuthenticationHelper2.default(this.deviceGroupKey, this.pool.getParanoia());
	      var dateHelper = new _DateHelper2.default();
	
	      var authParameters = {};
	
	      authParameters.USERNAME = this.username;
	      authParameters.DEVICE_KEY = this.deviceKey;
	      authParameters.SRP_A = authenticationHelper.getLargeAValue().toString(16);
	
	      this.client.makeUnauthenticatedRequest('respondToAuthChallenge', {
	        ChallengeName: 'DEVICE_SRP_AUTH',
	        ClientId: this.pool.getClientId(),
	        ChallengeResponses: authParameters
	      }, function (err, data) {
	        if (err) {
	          return callback.onFailure(err);
	        }
	
	        var challengeParameters = data.ChallengeParameters;
	
	        var serverBValue = new _jsbn.BigInteger(challengeParameters.SRP_B, 16);
	        var salt = new _jsbn.BigInteger(challengeParameters.SALT, 16);
	
	        var hkdf = authenticationHelper.getPasswordAuthenticationKey(_this2.deviceKey, _this2.randomPassword, serverBValue, salt);
	        var secretBlockBits = sjcl.codec.base64.toBits(challengeParameters.SECRET_BLOCK);
	
	        var mac = new sjcl.misc.hmac(hkdf, sjcl.hash.sha256);
	        mac.update(sjcl.codec.utf8String.toBits(_this2.deviceGroupKey));
	        mac.update(sjcl.codec.utf8String.toBits(_this2.deviceKey));
	        mac.update(secretBlockBits);
	        var dateNow = dateHelper.getNowString();
	        mac.update(sjcl.codec.utf8String.toBits(dateNow));
	        var signature = mac.digest();
	        var signatureString = sjcl.codec.base64.fromBits(signature);
	
	        var challengeResponses = {};
	
	        challengeResponses.USERNAME = _this2.username;
	        challengeResponses.PASSWORD_CLAIM_SECRET_BLOCK = challengeParameters.SECRET_BLOCK;
	        challengeResponses.TIMESTAMP = dateNow;
	        challengeResponses.PASSWORD_CLAIM_SIGNATURE = signatureString;
	        challengeResponses.DEVICE_KEY = _this2.deviceKey;
	
	        _this2.client.makeUnauthenticatedRequest('respondToAuthChallenge', {
	          ChallengeName: 'DEVICE_PASSWORD_VERIFIER',
	          ClientId: _this2.pool.getClientId(),
	          ChallengeResponses: challengeResponses,
	          Session: data.Session
	        }, function (errAuthenticate, dataAuthenticate) {
	          if (errAuthenticate) {
	            return callback.onFailure(errAuthenticate);
	          }
	
	          _this2.signInUserSession = _this2.getCognitoUserSession(dataAuthenticate.AuthenticationResult);
	          _this2.cacheTokens();
	
	          return callback.onSuccess(_this2.signInUserSession);
	        });
	        return undefined;
	      });
	    }
	
	    /**
	     * This is used for a certain user to confirm the registration by using a confirmation code
	     * @param {string} confirmationCode Code entered by user.
	     * @param {bool} forceAliasCreation Allow migrating from an existing email / phone number.
	     * @param {nodeCallback<string>} callback Called on success or error.
	     * @returns {void}
	     */
	
	  }, {
	    key: 'confirmRegistration',
	    value: function confirmRegistration(confirmationCode, forceAliasCreation, callback) {
	      this.client.makeUnauthenticatedRequest('confirmSignUp', {
	        ClientId: this.pool.getClientId(),
	        ConfirmationCode: confirmationCode,
	        Username: this.username,
	        ForceAliasCreation: forceAliasCreation
	      }, function (err) {
	        if (err) {
	          return callback(err, null);
	        }
	        return callback(null, 'SUCCESS');
	      });
	    }
	
	    /**
	     * This is used by the user once he has the responses to a custom challenge
	     * @param {string} answerChallenge The custom challange answer.
	     * @param {object} callback Result callback map.
	     * @param {onFailure} callback.onFailure Called on any error.
	     * @param {customChallenge} callback.customChallenge
	     *    Custom challenge response required to continue.
	     * @param {authSuccess} callback.onSuccess Called on success with the new session.
	     * @returns {void}
	     */
	
	  }, {
	    key: 'sendCustomChallengeAnswer',
	    value: function sendCustomChallengeAnswer(answerChallenge, callback) {
	      var _this3 = this;
	
	      var challengeResponses = {};
	      challengeResponses.USERNAME = this.username;
	      challengeResponses.ANSWER = answerChallenge;
	
	      this.client.makeUnauthenticatedRequest('respondToAuthChallenge', {
	        ChallengeName: 'CUSTOM_CHALLENGE',
	        ChallengeResponses: challengeResponses,
	        ClientId: this.pool.getClientId(),
	        Session: this.Session
	      }, function (err, data) {
	        if (err) {
	          return callback.onFailure(err);
	        }
	
	        var challengeName = data.ChallengeName;
	
	        if (challengeName === 'CUSTOM_CHALLENGE') {
	          _this3.Session = data.Session;
	          return callback.customChallenge(data.challengeParameters);
	        }
	
	        _this3.signInUserSession = _this3.getCognitoUserSession(data.AuthenticationResult);
	        _this3.cacheTokens();
	        return callback.onSuccess(_this3.signInUserSession);
	      });
	    }
	
	    /**
	     * This is used by the user once he has an MFA code
	     * @param {string} confirmationCode The MFA code entered by the user.
	     * @param {object} callback Result callback map.
	     * @param {onFailure} callback.onFailure Called on any error.
	     * @param {authSuccess} callback.onSuccess Called on success with the new session.
	     * @returns {void}
	     */
	
	  }, {
	    key: 'sendMFACode',
	    value: function sendMFACode(confirmationCode, callback) {
	      var _this4 = this;
	
	      var challengeResponses = {};
	      challengeResponses.USERNAME = this.username;
	      challengeResponses.SMS_MFA_CODE = confirmationCode;
	
	      if (this.deviceKey != null) {
	        challengeResponses.DEVICE_KEY = this.deviceKey;
	      }
	
	      this.client.makeUnauthenticatedRequest('respondToAuthChallenge', {
	        ChallengeName: 'SMS_MFA',
	        ChallengeResponses: challengeResponses,
	        ClientId: this.pool.getClientId(),
	        Session: this.Session
	      }, function (err, dataAuthenticate) {
	        if (err) {
	          return callback.onFailure(err);
	        }
	
	        _this4.signInUserSession = _this4.getCognitoUserSession(dataAuthenticate.AuthenticationResult);
	        _this4.cacheTokens();
	
	        if (dataAuthenticate.AuthenticationResult.NewDeviceMetadata == null) {
	          return callback.onSuccess(_this4.signInUserSession);
	        }
	
	        var authenticationHelper = new _AuthenticationHelper2.default(_this4.pool.getUserPoolId().split('_')[1], _this4.pool.getParanoia());
	        authenticationHelper.generateHashDevice(dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceGroupKey, dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceKey);
	
	        var deviceSecretVerifierConfig = {
	          Salt: sjcl.codec.base64.fromBits(sjcl.codec.hex.toBits(authenticationHelper.getSaltDevices().toString(16))),
	          PasswordVerifier: sjcl.codec.base64.fromBits(sjcl.codec.hex.toBits(authenticationHelper.getVerifierDevices().toString(16)))
	        };
	
	        _this4.verifierDevices = sjcl.codec.base64.fromBits(authenticationHelper.getVerifierDevices());
	        _this4.deviceGroupKey = dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceGroupKey;
	        _this4.randomPassword = authenticationHelper.getRandomPassword();
	
	        _this4.client.makeUnauthenticatedRequest('confirmDevice', {
	          DeviceKey: dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceKey,
	          AccessToken: _this4.signInUserSession.getAccessToken().getJwtToken(),
	          DeviceSecretVerifierConfig: deviceSecretVerifierConfig,
	          DeviceName: navigator.userAgent
	        }, function (errConfirm, dataConfirm) {
	          if (errConfirm) {
	            return callback.onFailure(errConfirm);
	          }
	
	          _this4.deviceKey = dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceKey;
	          _this4.cacheDeviceKeyAndPassword();
	          if (dataConfirm.UserConfirmationNecessary === true) {
	            return callback.onSuccess(_this4.signInUserSession, dataConfirm.UserConfirmationNecessary);
	          }
	          return callback.onSuccess(_this4.signInUserSession);
	        });
	        return undefined;
	      });
	    }
	
	    /**
	     * This is used by an authenticated user to change the current password
	     * @param {string} oldUserPassword The current password.
	     * @param {string} newUserPassword The requested new password.
	     * @param {nodeCallback<string>} callback Called on success or error.
	     * @returns {void}
	     */
	
	  }, {
	    key: 'changePassword',
	    value: function changePassword(oldUserPassword, newUserPassword, callback) {
	      if (!(this.signInUserSession != null && this.signInUserSession.isValid())) {
	        return callback(new Error('User is not authenticated'), null);
	      }
	
	      this.client.makeUnauthenticatedRequest('changePassword', {
	        PreviousPassword: oldUserPassword,
	        ProposedPassword: newUserPassword,
	        AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
	      }, function (err) {
	        if (err) {
	          return callback(err, null);
	        }
	        return callback(null, 'SUCCESS');
	      });
	      return undefined;
	    }
	
	    /**
	     * This is used by an authenticated user to enable MFA for himself
	     * @param {nodeCallback<string>} callback Called on success or error.
	     * @returns {void}
	     */
	
	  }, {
	    key: 'enableMFA',
	    value: function enableMFA(callback) {
	      if (this.signInUserSession == null || !this.signInUserSession.isValid()) {
	        return callback(new Error('User is not authenticated'), null);
	      }
	
	      var mfaOptions = [];
	      var mfaEnabled = {
	        DeliveryMedium: 'SMS',
	        AttributeName: 'phone_number'
	      };
	      mfaOptions.push(mfaEnabled);
	
	      this.client.makeUnauthenticatedRequest('setUserSettings', {
	        MFAOptions: mfaOptions,
	        AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
	      }, function (err) {
	        if (err) {
	          return callback(err, null);
	        }
	        return callback(null, 'SUCCESS');
	      });
	      return undefined;
	    }
	
	    /**
	     * This is used by an authenticated user to disable MFA for himself
	     * @param {nodeCallback<string>} callback Called on success or error.
	     * @returns {void}
	     */
	
	  }, {
	    key: 'disableMFA',
	    value: function disableMFA(callback) {
	      if (this.signInUserSession == null || !this.signInUserSession.isValid()) {
	        return callback(new Error('User is not authenticated'), null);
	      }
	
	      var mfaOptions = [];
	
	      this.client.makeUnauthenticatedRequest('setUserSettings', {
	        MFAOptions: mfaOptions,
	        AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
	      }, function (err) {
	        if (err) {
	          return callback(err, null);
	        }
	        return callback(null, 'SUCCESS');
	      });
	      return undefined;
	    }
	
	    /**
	     * This is used by an authenticated user to delete himself
	     * @param {nodeCallback<string>} callback Called on success or error.
	     * @returns {void}
	     */
	
	  }, {
	    key: 'deleteUser',
	    value: function deleteUser(callback) {
	      if (this.signInUserSession == null || !this.signInUserSession.isValid()) {
	        return callback(new Error('User is not authenticated'), null);
	      }
	
	      this.client.makeUnauthenticatedRequest('deleteUser', {
	        AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
	      }, function (err) {
	        if (err) {
	          return callback(err, null);
	        }
	        return callback(null, 'SUCCESS');
	      });
	      return undefined;
	    }
	
	    /**
	     * @typedef {CognitoUserAttribute | { Name:string, Value:string }} AttributeArg
	     */
	    /**
	     * This is used by an authenticated user to change a list of attributes
	     * @param {AttributeArg[]} attributes A list of the new user attributes.
	     * @param {nodeCallback<string>} callback Called on success or error.
	     * @returns {void}
	     */
	
	  }, {
	    key: 'updateAttributes',
	    value: function updateAttributes(attributes, callback) {
	      if (this.signInUserSession == null || !this.signInUserSession.isValid()) {
	        return callback(new Error('User is not authenticated'), null);
	      }
	
	      this.client.makeUnauthenticatedRequest('updateUserAttributes', {
	        AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
	        UserAttributes: attributes
	      }, function (err) {
	        if (err) {
	          return callback(err, null);
	        }
	        return callback(null, 'SUCCESS');
	      });
	      return undefined;
	    }
	
	    /**
	     * This is used by an authenticated user to get a list of attributes
	     * @param {nodeCallback<CognitoUserAttribute[]>} callback Called on success or error.
	     * @returns {void}
	     */
	
	  }, {
	    key: 'getUserAttributes',
	    value: function getUserAttributes(callback) {
	      if (!(this.signInUserSession != null && this.signInUserSession.isValid())) {
	        return callback(new Error('User is not authenticated'), null);
	      }
	
	      this.client.makeUnauthenticatedRequest('getUser', {
	        AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
	      }, function (err, userData) {
	        if (err) {
	          return callback(err, null);
	        }
	
	        var attributeList = [];
	
	        for (var i = 0; i < userData.UserAttributes.length; i++) {
	          var attribute = {
	            Name: userData.UserAttributes[i].Name,
	            Value: userData.UserAttributes[i].Value
	          };
	          var userAttribute = new _CognitoUserAttribute2.default(attribute);
	          attributeList.push(userAttribute);
	        }
	
	        return callback(null, attributeList);
	      });
	      return undefined;
	    }
	
	    /**
	     * This is used by an authenticated user to delete a list of attributes
	     * @param {string[]} attributeList Names of the attributes to delete.
	     * @param {nodeCallback<string>} callback Called on success or error.
	     * @returns {void}
	     */
	
	  }, {
	    key: 'deleteAttributes',
	    value: function deleteAttributes(attributeList, callback) {
	      if (!(this.signInUserSession != null && this.signInUserSession.isValid())) {
	        return callback(new Error('User is not authenticated'), null);
	      }
	
	      this.client.makeUnauthenticatedRequest('deleteUserAttributes', {
	        UserAttributeNames: attributeList,
	        AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
	      }, function (err) {
	        if (err) {
	          return callback(err, null);
	        }
	        return callback(null, 'SUCCESS');
	      });
	      return undefined;
	    }
	
	    /**
	     * This is used by a user to resend a confirmation code
	     * @param {nodeCallback<string>} callback Called on success or error.
	     * @returns {void}
	     */
	
	  }, {
	    key: 'resendConfirmationCode',
	    value: function resendConfirmationCode(callback) {
	      this.client.makeUnauthenticatedRequest('resendConfirmationCode', {
	        ClientId: this.pool.getClientId(),
	        Username: this.username
	      }, function (err) {
	        if (err) {
	          return callback(err, null);
	        }
	        return callback(null, 'SUCCESS');
	      });
	    }
	
	    /**
	     * This is used to get a session, either from the session object
	     * or from  the local storage, or by using a refresh token
	     *
	     * @param {nodeCallback<CognitoUserSession>} callback Called on success or error.
	     * @returns {void}
	     */
	
	  }, {
	    key: 'getSession',
	    value: function getSession(callback) {
	      if (this.username == null) {
	        return callback(new Error('Username is null. Cannot retrieve a new session'), null);
	      }
	
	      if (this.signInUserSession != null && this.signInUserSession.isValid()) {
	        return callback(null, this.signInUserSession);
	      }
	
	      var keyPrefix = 'CognitoIdentityServiceProvider.' + this.pool.getClientId() + '.' + this.username;
	      var idTokenKey = keyPrefix + '.idToken';
	      var accessTokenKey = keyPrefix + '.accessToken';
	      var refreshTokenKey = keyPrefix + '.refreshToken';
	
	      var storage = window.localStorage;
	
	      if (storage.getItem(idTokenKey)) {
	        var idToken = new _CognitoIdToken2.default({
	          IdToken: storage.getItem(idTokenKey)
	        });
	        var accessToken = new _CognitoAccessToken2.default({
	          AccessToken: storage.getItem(accessTokenKey)
	        });
	        var refreshToken = new _CognitoRefreshToken2.default({
	          RefreshToken: storage.getItem(refreshTokenKey)
	        });
	
	        var sessionData = {
	          IdToken: idToken,
	          AccessToken: accessToken,
	          RefreshToken: refreshToken
	        };
	        var cachedSession = new _CognitoUserSession2.default(sessionData);
	        if (cachedSession.isValid()) {
	          this.signInUserSession = cachedSession;
	          return callback(null, this.signInUserSession);
	        }
	
	        if (refreshToken.getToken() == null) {
	          return callback(new Error('Cannot retrieve a new session. Please authenticate.'), null);
	        }
	
	        this.refreshSession(refreshToken, callback);
	      }
	      return undefined;
	    }
	
	    /**
	     * This uses the refreshToken to retrieve a new session
	     * @param {CognitoRefreshToken} refreshToken A previous session's refresh token.
	     * @param {nodeCallback<CognitoUserSession>} callback Called on success or error.
	     * @returns {void}
	     */
	
	  }, {
	    key: 'refreshSession',
	    value: function refreshSession(refreshToken, callback) {
	      var _this5 = this;
	
	      var authParameters = {};
	      authParameters.REFRESH_TOKEN = refreshToken.getToken();
	      var keyPrefix = 'CognitoIdentityServiceProvider.' + this.pool.getClientId();
	      var lastUserKey = keyPrefix + '.LastAuthUser';
	      var storage = window.localStorage;
	
	      if (storage.getItem(lastUserKey)) {
	        this.username = storage.getItem(lastUserKey);
	        var deviceKeyKey = keyPrefix + '.' + this.username + '.deviceKey';
	        this.deviceKey = storage.getItem(deviceKeyKey);
	        authParameters.DEVICE_KEY = this.deviceKey;
	      }
	
	      this.client.makeUnauthenticatedRequest('initiateAuth', {
	        ClientId: this.pool.getClientId(),
	        AuthFlow: 'REFRESH_TOKEN_AUTH',
	        AuthParameters: authParameters
	      }, function (err, authResult) {
	        if (err) {
	          return callback(err, null);
	        }
	        if (authResult) {
	          var authenticationResult = authResult.AuthenticationResult;
	          if (!Object.prototype.hasOwnProperty.call(authenticationResult, 'RefreshToken')) {
	            authenticationResult.RefreshToken = refreshToken.getToken();
	          }
	          _this5.signInUserSession = _this5.getCognitoUserSession(authenticationResult);
	          _this5.cacheTokens();
	          return callback(null, _this5.signInUserSession);
	        }
	        return undefined;
	      });
	    }
	
	    /**
	     * This is used to save the session tokens to local storage
	     * @returns {void}
	     */
	
	  }, {
	    key: 'cacheTokens',
	    value: function cacheTokens() {
	      var keyPrefix = 'CognitoIdentityServiceProvider.' + this.pool.getClientId();
	      var idTokenKey = keyPrefix + '.' + this.username + '.idToken';
	      var accessTokenKey = keyPrefix + '.' + this.username + '.accessToken';
	      var refreshTokenKey = keyPrefix + '.' + this.username + '.refreshToken';
	      var lastUserKey = keyPrefix + '.LastAuthUser';
	
	      var storage = window.localStorage;
	
	      storage.setItem(idTokenKey, this.signInUserSession.getIdToken().getJwtToken());
	      storage.setItem(accessTokenKey, this.signInUserSession.getAccessToken().getJwtToken());
	      storage.setItem(refreshTokenKey, this.signInUserSession.getRefreshToken().getToken());
	      storage.setItem(lastUserKey, this.username);
	    }
	
	    /**
	     * This is used to cache the device key and device group and device password
	     * @returns {void}
	     */
	
	  }, {
	    key: 'cacheDeviceKeyAndPassword',
	    value: function cacheDeviceKeyAndPassword() {
	      var keyPrefix = 'CognitoIdentityServiceProvider.' + this.pool.getClientId() + '.' + this.username;
	      var deviceKeyKey = keyPrefix + '.deviceKey';
	      var randomPasswordKey = keyPrefix + '.randomPasswordKey';
	      var deviceGroupKeyKey = keyPrefix + '.deviceGroupKey';
	
	      var storage = window.localStorage;
	
	      storage.setItem(deviceKeyKey, this.deviceKey);
	      storage.setItem(randomPasswordKey, this.randomPassword);
	      storage.setItem(deviceGroupKeyKey, this.deviceGroupKey);
	    }
	
	    /**
	     * This is used to get current device key and device group and device password
	     * @returns {void}
	     */
	
	  }, {
	    key: 'getCachedDeviceKeyAndPassword',
	    value: function getCachedDeviceKeyAndPassword() {
	      var keyPrefix = 'CognitoIdentityServiceProvider.' + this.pool.getClientId() + '.' + this.username;
	      var deviceKeyKey = keyPrefix + '.deviceKey';
	      var randomPasswordKey = keyPrefix + '.randomPasswordKey';
	      var deviceGroupKeyKey = keyPrefix + '.deviceGroupKey';
	
	      var storage = window.localStorage;
	
	      if (storage.getItem(deviceKeyKey)) {
	        this.deviceKey = storage.getItem(deviceKeyKey);
	        this.randomPassword = storage.getItem(randomPasswordKey);
	        this.deviceGroupKey = storage.getItem(deviceGroupKeyKey);
	      }
	    }
	
	    /**
	     * This is used to clear the device key info from local storage
	     * @returns {void}
	     */
	
	  }, {
	    key: 'clearCachedDeviceKeyAndPassword',
	    value: function clearCachedDeviceKeyAndPassword() {
	      var keyPrefix = 'CognitoIdentityServiceProvider.' + this.pool.getClientId() + '.' + this.username;
	      var deviceKeyKey = keyPrefix + '.deviceKey';
	      var randomPasswordKey = keyPrefix + '.randomPasswordKey';
	      var deviceGroupKeyKey = keyPrefix + '.deviceGroupKey';
	
	      var storage = window.localStorage;
	
	      storage.removeItem(deviceKeyKey);
	      storage.removeItem(randomPasswordKey);
	      storage.removeItem(deviceGroupKeyKey);
	    }
	
	    /**
	     * This is used to clear the session tokens from local storage
	     * @returns {void}
	     */
	
	  }, {
	    key: 'clearCachedTokens',
	    value: function clearCachedTokens() {
	      var keyPrefix = 'CognitoIdentityServiceProvider.' + this.pool.getClientId();
	      var idTokenKey = keyPrefix + '.' + this.username + '.idToken';
	      var accessTokenKey = keyPrefix + '.' + this.username + '.accessToken';
	      var refreshTokenKey = keyPrefix + '.' + this.username + '.refreshToken';
	      var lastUserKey = keyPrefix + '.LastAuthUser';
	
	      var storage = window.localStorage;
	
	      storage.removeItem(idTokenKey);
	      storage.removeItem(accessTokenKey);
	      storage.removeItem(refreshTokenKey);
	      storage.removeItem(lastUserKey);
	    }
	
	    /**
	     * This is used to build a user session from tokens retrieved in the authentication result
	     * @param {object} authResult Successful auth response from server.
	     * @returns {CognitoUserSession} The new user session.
	     * @private
	     */
	
	  }, {
	    key: 'getCognitoUserSession',
	    value: function getCognitoUserSession(authResult) {
	      var idToken = new _CognitoIdToken2.default(authResult);
	      var accessToken = new _CognitoAccessToken2.default(authResult);
	      var refreshToken = new _CognitoRefreshToken2.default(authResult);
	
	      var sessionData = {
	        IdToken: idToken,
	        AccessToken: accessToken,
	        RefreshToken: refreshToken
	      };
	
	      return new _CognitoUserSession2.default(sessionData);
	    }
	
	    /**
	     * This is used to initiate a forgot password request
	     * @param {object} callback Result callback map.
	     * @param {onFailure} callback.onFailure Called on any error.
	     * @param {inputVerificationCode?} callback.inputVerificationCode
	     *    Optional callback raised instead of onSuccess with response data.
	     * @param {onSuccess<void>?} callback.onSuccess Called on success.
	     * @returns {void}
	     */
	
	  }, {
	    key: 'forgotPassword',
	    value: function forgotPassword(callback) {
	      this.client.makeUnauthenticatedRequest('forgotPassword', {
	        ClientId: this.pool.getClientId(),
	        Username: this.username
	      }, function (err, data) {
	        if (err) {
	          return callback.onFailure(err);
	        }
	        if (typeof callback.inputVerificationCode === 'function') {
	          return callback.inputVerificationCode(data);
	        }
	        return callback.onSuccess();
	      });
	    }
	
	    /**
	     * This is used to confirm a new password using a confirmationCode
	     * @param {string} confirmationCode Code entered by user.
	     * @param {string} newPassword Confirm new password.
	     * @param {object} callback Result callback map.
	     * @param {onFailure} callback.onFailure Called on any error.
	     * @param {onSuccess<void>} callback.onSuccess Called on success.
	     * @returns {void}
	     */
	
	  }, {
	    key: 'confirmPassword',
	    value: function confirmPassword(confirmationCode, newPassword, callback) {
	      this.client.makeUnauthenticatedRequest('confirmForgotPassword', {
	        ClientId: this.pool.getClientId(),
	        Username: this.username,
	        ConfirmationCode: confirmationCode,
	        Password: newPassword
	      }, function (err) {
	        if (err) {
	          return callback.onFailure(err);
	        }
	        return callback.onSuccess();
	      });
	    }
	
	    /**
	     * This is used to initiate an attribute confirmation request
	     * @param {string} attributeName User attribute that needs confirmation.
	     * @param {object} callback Result callback map.
	     * @param {onFailure} callback.onFailure Called on any error.
	     * @param {inputVerificationCode} callback.inputVerificationCode Called on success.
	     * @returns {void}
	     */
	
	  }, {
	    key: 'getAttributeVerificationCode',
	    value: function getAttributeVerificationCode(attributeName, callback) {
	      if (this.signInUserSession == null || !this.signInUserSession.isValid()) {
	        return callback(new Error('User is not authenticated'), null);
	      }
	
	      this.client.makeUnauthenticatedRequest('getUserAttributeVerificationCode', {
	        AttributeName: attributeName,
	        AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
	      }, function (err, data) {
	        if (err) {
	          return callback.onFailure(err);
	        }
	        return callback.inputVerificationCode(data);
	      });
	      return undefined;
	    }
	
	    /**
	     * This is used to confirm an attribute using a confirmation code
	     * @param {string} attributeName Attribute being confirmed.
	     * @param {string} confirmationCode Code entered by user.
	     * @param {object} callback Result callback map.
	     * @param {onFailure} callback.onFailure Called on any error.
	     * @param {onSuccess<string>} callback.onSuccess Called on success.
	     * @returns {void}
	     */
	
	  }, {
	    key: 'verifyAttribute',
	    value: function verifyAttribute(attributeName, confirmationCode, callback) {
	      if (this.signInUserSession == null || !this.signInUserSession.isValid()) {
	        return callback(new Error('User is not authenticated'), null);
	      }
	
	      this.client.makeUnauthenticatedRequest('verifyUserAttribute', {
	        AttributeName: attributeName,
	        Code: confirmationCode,
	        AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
	      }, function (err) {
	        if (err) {
	          return callback.onFailure(err);
	        }
	        return callback.onSuccess('SUCCESS');
	      });
	      return undefined;
	    }
	
	    /**
	     * This is used to get the device information using the current device key
	     * @param {object} callback Result callback map.
	     * @param {onFailure} callback.onFailure Called on any error.
	     * @param {onSuccess<*>} callback.onSuccess Called on success with device data.
	     * @returns {void}
	     */
	
	  }, {
	    key: 'getDevice',
	    value: function getDevice(callback) {
	      if (this.signInUserSession == null || !this.signInUserSession.isValid()) {
	        return callback(new Error('User is not authenticated'), null);
	      }
	
	      this.client.makeUnauthenticatedRequest('getDevice', {
	        AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
	        DeviceKey: this.deviceKey
	      }, function (err, data) {
	        if (err) {
	          return callback.onFailure(err);
	        }
	        return callback.onSuccess(data);
	      });
	      return undefined;
	    }
	
	    /**
	     * This is used to forget the current device
	     * @param {object} callback Result callback map.
	     * @param {onFailure} callback.onFailure Called on any error.
	     * @param {onSuccess<string>} callback.onSuccess Called on success.
	     * @returns {void}
	     */
	
	  }, {
	    key: 'forgetDevice',
	    value: function forgetDevice(callback) {
	      var _this6 = this;
	
	      if (this.signInUserSession == null || !this.signInUserSession.isValid()) {
	        return callback(new Error('User is not authenticated'), null);
	      }
	
	      this.client.makeUnauthenticatedRequest('forgetDevice', {
	        AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
	        DeviceKey: this.deviceKey
	      }, function (err) {
	        if (err) {
	          return callback.onFailure(err);
	        }
	        _this6.deviceKey = null;
	        _this6.deviceGroupkey = null;
	        _this6.randomPassword = null;
	        _this6.clearCachedDeviceKeyAndPassword();
	        return callback.onSuccess('SUCCESS');
	      });
	      return undefined;
	    }
	
	    /**
	     * This is used to set the device status as remembered
	     * @param {object} callback Result callback map.
	     * @param {onFailure} callback.onFailure Called on any error.
	     * @param {onSuccess<string>} callback.onSuccess Called on success.
	     * @returns {void}
	     */
	
	  }, {
	    key: 'setDeviceStatusRemembered',
	    value: function setDeviceStatusRemembered(callback) {
	      if (this.signInUserSession == null || !this.signInUserSession.isValid()) {
	        return callback(new Error('User is not authenticated'), null);
	      }
	
	      this.client.makeUnauthenticatedRequest('updateDeviceStatus', {
	        AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
	        DeviceKey: this.deviceKey,
	        DeviceRememberedStatus: 'remembered'
	      }, function (err) {
	        if (err) {
	          return callback.onFailure(err);
	        }
	        return callback.onSuccess('SUCCESS');
	      });
	      return undefined;
	    }
	
	    /**
	     * This is used to set the device status as not remembered
	     * @param {object} callback Result callback map.
	     * @param {onFailure} callback.onFailure Called on any error.
	     * @param {onSuccess<string>} callback.onSuccess Called on success.
	     * @returns {void}
	     */
	
	  }, {
	    key: 'setDeviceStatusNotRemembered',
	    value: function setDeviceStatusNotRemembered(callback) {
	      if (this.signInUserSession == null || !this.signInUserSession.isValid()) {
	        return callback(new Error('User is not authenticated'), null);
	      }
	
	      this.client.makeUnauthenticatedRequest('updateDeviceStatus', {
	        AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
	        DeviceKey: this.deviceKey,
	        DeviceRememberedStatus: 'not_remembered'
	      }, function (err) {
	        if (err) {
	          return callback.onFailure(err);
	        }
	        return callback.onSuccess('SUCCESS');
	      });
	      return undefined;
	    }
	
	    /**
	     * This is used to list all devices for a user
	     *
	     * @param {int} limit the number of devices returned in a call
	     * @param {string} paginationToken the pagination token in case any was returned before
	     * @param {object} callback Result callback map.
	     * @param {onFailure} callback.onFailure Called on any error.
	     * @param {onSuccess<*>} callback.onSuccess Called on success with device list.
	     * @returns {void}
	     */
	
	  }, {
	    key: 'listDevices',
	    value: function listDevices(limit, paginationToken, callback) {
	      if (this.signInUserSession == null || !this.signInUserSession.isValid()) {
	        return callback(new Error('User is not authenticated'), null);
	      }
	
	      this.client.makeUnauthenticatedRequest('listDevices', {
	        AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
	        Limit: limit,
	        PaginationToken: paginationToken
	      }, function (err, data) {
	        if (err) {
	          return callback.onFailure(err);
	        }
	        return callback.onSuccess(data);
	      });
	      return undefined;
	    }
	
	    /**
	     * This is used to globally revoke all tokens issued to a user
	     * @param {object} callback Result callback map.
	     * @param {onFailure} callback.onFailure Called on any error.
	     * @param {onSuccess<string>} callback.onSuccess Called on success.
	     * @returns {void}
	     */
	
	  }, {
	    key: 'globalSignOut',
	    value: function globalSignOut(callback) {
	      var _this7 = this;
	
	      if (this.signInUserSession == null || !this.signInUserSession.isValid()) {
	        return callback(new Error('User is not authenticated'), null);
	      }
	
	      this.client.makeUnauthenticatedRequest('globalSignOut', {
	        AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
	      }, function (err) {
	        if (err) {
	          return callback.onFailure(err);
	        }
	        _this7.clearCachedTokens();
	        return callback.onSuccess('SUCCESS');
	      });
	      return undefined;
	    }
	
	    /**
	     * This is used for the user to signOut of the application and clear the cached tokens.
	     * @returns {void}
	     */
	
	  }, {
	    key: 'signOut',
	    value: function signOut() {
	      this.signInUserSession = null;
	      this.clearCachedTokens();
	    }
	  }]);
	
	  return CognitoUser;
	}();
	
	exports.default = CognitoUser;

/***/ },
/* 7 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/*!
	 * Copyright 2016 Amazon.com,
	 * Inc. or its affiliates. All Rights Reserved.
	 *
	 * Licensed under the Amazon Software License (the "License").
	 * You may not use this file except in compliance with the
	 * License. A copy of the License is located at
	 *
	 *     http://aws.amazon.com/asl/
	 *
	 * or in the "license" file accompanying this file. This file is
	 * distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
	 * CONDITIONS OF ANY KIND, express or implied. See the License
	 * for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	/** @class */
	var CognitoUserAttribute = function () {
	  /**
	   * Constructs a new CognitoUserAttribute object
	   * @param {string=} Name The record's name
	   * @param {string=} Value The record's value
	   */
	  function CognitoUserAttribute() {
	    var _ref = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	    var Name = _ref.Name;
	    var Value = _ref.Value;
	
	    _classCallCheck(this, CognitoUserAttribute);
	
	    this.Name = Name || '';
	    this.Value = Value || '';
	  }
	
	  /**
	   * @returns {string} the record's value.
	   */
	
	
	  _createClass(CognitoUserAttribute, [{
	    key: 'getValue',
	    value: function getValue() {
	      return this.Value;
	    }
	
	    /**
	     * Sets the record's value.
	     * @param {string} value The new value.
	     * @returns {CognitoUserAttribute} The record for method chaining.
	     */
	
	  }, {
	    key: 'setValue',
	    value: function setValue(value) {
	      this.Value = value;
	      return this;
	    }
	
	    /**
	     * @returns {string} the record's name.
	     */
	
	  }, {
	    key: 'getName',
	    value: function getName() {
	      return this.Name;
	    }
	
	    /**
	     * Sets the record's name
	     * @param {string} name The new name.
	     * @returns {CognitoUserAttribute} The record for method chaining.
	     */
	
	  }, {
	    key: 'setName',
	    value: function setName(name) {
	      this.Name = name;
	      return this;
	    }
	
	    /**
	     * @returns {string} a string representation of the record.
	     */
	
	  }, {
	    key: 'toString',
	    value: function toString() {
	      return JSON.stringify(this);
	    }
	
	    /**
	     * @returns {object} a flat object representing the record.
	     */
	
	  }, {
	    key: 'toJSON',
	    value: function toJSON() {
	      return {
	        Name: this.Name,
	        Value: this.Value
	      };
	    }
	  }]);
	
	  return CognitoUserAttribute;
	}();
	
	exports.default = CognitoUserAttribute;

/***/ },
/* 8 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/*!
	 * Copyright 2016 Amazon.com,
	 * Inc. or its affiliates. All Rights Reserved.
	 *
	 * Licensed under the Amazon Software License (the "License").
	 * You may not use this file except in compliance with the
	 * License. A copy of the License is located at
	 *
	 *     http://aws.amazon.com/asl/
	 *
	 * or in the "license" file accompanying this file. This file is
	 * distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
	 * CONDITIONS OF ANY KIND, express or implied. See the License
	 * for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	/** @class */
	var CognitoUserSession = function () {
	  /**
	   * Constructs a new CognitoUserSession object
	   * @param {string} IdToken The session's Id token.
	   * @param {string=} RefreshToken The session's refresh token.
	   * @param {string} AccessToken The session's access token.
	   */
	  function CognitoUserSession() {
	    var _ref = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	    var IdToken = _ref.IdToken;
	    var RefreshToken = _ref.RefreshToken;
	    var AccessToken = _ref.AccessToken;
	
	    _classCallCheck(this, CognitoUserSession);
	
	    if (AccessToken == null || IdToken == null) {
	      throw new Error('Id token and Access Token must be present.');
	    }
	
	    this.idToken = IdToken;
	    this.refreshToken = RefreshToken;
	    this.accessToken = AccessToken;
	  }
	
	  /**
	   * @returns {CognitoIdToken} the session's Id token
	   */
	
	
	  _createClass(CognitoUserSession, [{
	    key: 'getIdToken',
	    value: function getIdToken() {
	      return this.idToken;
	    }
	
	    /**
	     * @returns {CognitoRefreshToken} the session's refresh token
	     */
	
	  }, {
	    key: 'getRefreshToken',
	    value: function getRefreshToken() {
	      return this.refreshToken;
	    }
	
	    /**
	     * @returns {CognitoAccessToken} the session's access token
	     */
	
	  }, {
	    key: 'getAccessToken',
	    value: function getAccessToken() {
	      return this.accessToken;
	    }
	
	    /**
	     * Checks to see if the session is still valid based on session expiry information found
	     * in tokens and the current time
	     * @returns {boolean} if the session is still valid
	     */
	
	  }, {
	    key: 'isValid',
	    value: function isValid() {
	      var now = Math.floor(new Date() / 1000);
	
	      return now < this.accessToken.getExpiration() && now < this.idToken.getExpiration();
	    }
	  }]);
	
	  return CognitoUserSession;
	}();
	
	exports.default = CognitoUserSession;

/***/ },
/* 9 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/*!
	 * Copyright 2016 Amazon.com,
	 * Inc. or its affiliates. All Rights Reserved.
	 *
	 * Licensed under the Amazon Software License (the "License").
	 * You may not use this file except in compliance with the
	 * License. A copy of the License is located at
	 *
	 *     http://aws.amazon.com/asl/
	 *
	 * or in the "license" file accompanying this file. This file is
	 * distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
	 * CONDITIONS OF ANY KIND, express or implied. See the License
	 * for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	var monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
	var weekNames = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
	
	/** @class */
	
	var DateHelper = function () {
	  function DateHelper() {
	    _classCallCheck(this, DateHelper);
	  }
	
	  _createClass(DateHelper, [{
	    key: 'getNowString',
	
	    /**
	     * @returns {string} The current time in "ddd MMM D HH:mm:ss UTC YYYY" format.
	     */
	    value: function getNowString() {
	      var now = new Date();
	
	      var weekDay = weekNames[now.getUTCDay()];
	      var month = monthNames[now.getUTCMonth()];
	      var day = now.getUTCDate();
	
	      var hours = now.getUTCHours();
	      if (hours < 10) {
	        hours = '0' + hours;
	      }
	
	      var minutes = now.getUTCMinutes();
	      if (minutes < 10) {
	        minutes = '0' + minutes;
	      }
	
	      var seconds = now.getUTCSeconds();
	      if (seconds < 10) {
	        seconds = '0' + seconds;
	      }
	
	      var year = now.getUTCFullYear();
	
	      // ddd MMM D HH:mm:ss UTC YYYY
	      var dateNow = weekDay + ' ' + month + ' ' + day + ' ' + hours + ':' + minutes + ':' + seconds + ' UTC ' + year;
	
	      return dateNow;
	    }
	  }]);
	
	  return DateHelper;
	}();
	
	exports.default = DateHelper;

/***/ },
/* 10 */
/***/ function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_10__;

/***/ },
/* 11 */
/***/ function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_11__;

/***/ },
/* 12 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/*!
	 * Copyright 2016 Amazon.com,
	 * Inc. or its affiliates. All Rights Reserved.
	 *
	 * Licensed under the Amazon Software License (the "License").
	 * You may not use this file except in compliance with the
	 * License. A copy of the License is located at
	 *
	 *     http://aws.amazon.com/asl/
	 *
	 * or in the "license" file accompanying this file. This file is
	 * distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
	 * CONDITIONS OF ANY KIND, express or implied. See the License
	 * for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	/** @class */
	var AuthenticationDetails = function () {
	  /**
	   * Constructs a new AuthenticationDetails object
	   * @param {object=} data Creation options.
	   * @param {string} data.Username User being authenticated.
	   * @param {string} data.Password Plain-text password to authenticate with.
	   * @param {(AttributeArg[])?} data.ValidationData Application extra metadata.
	   */
	  function AuthenticationDetails(data) {
	    _classCallCheck(this, AuthenticationDetails);
	
	    var _ref = data || {};
	
	    var ValidationData = _ref.ValidationData;
	    var Username = _ref.Username;
	    var Password = _ref.Password;
	
	    this.validationData = ValidationData || [];
	    this.username = Username;
	    this.password = Password;
	  }
	
	  /**
	   * @returns {string} the record's username
	   */
	
	
	  _createClass(AuthenticationDetails, [{
	    key: "getUsername",
	    value: function getUsername() {
	      return this.username;
	    }
	
	    /**
	     * @returns {string} the record's password
	     */
	
	  }, {
	    key: "getPassword",
	    value: function getPassword() {
	      return this.password;
	    }
	
	    /**
	     * @returns {Array} the record's validationData
	     */
	
	  }, {
	    key: "getValidationData",
	    value: function getValidationData() {
	      return this.validationData;
	    }
	  }]);
	
	  return AuthenticationDetails;
	}();
	
	exports.default = AuthenticationDetails;

/***/ },
/* 13 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /*!
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Copyright 2016 Amazon.com,
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Inc. or its affiliates. All Rights Reserved.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Licensed under the Amazon Software License (the "License").
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * You may not use this file except in compliance with the
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * License. A copy of the License is located at
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *     http://aws.amazon.com/asl/
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * or in the "license" file accompanying this file. This file is
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * CONDITIONS OF ANY KIND, express or implied. See the License
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * for the specific language governing permissions and
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * limitations under the License.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */
	
	var _awsSdk = __webpack_require__(10);
	
	var _CognitoUser = __webpack_require__(6);
	
	var _CognitoUser2 = _interopRequireDefault(_CognitoUser);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/** @class */
	var CognitoUserPool = function () {
	  /**
	   * Constructs a new CognitoUserPool object
	   * @param {object} data Creation options.
	   * @param {string} data.UserPoolId Cognito user pool id.
	   * @param {string} data.ClientId User pool application client id.
	   * @param {int=} data.Paranoia Random number generation paranoia level.
	   */
	  function CognitoUserPool(data) {
	    _classCallCheck(this, CognitoUserPool);
	
	    var _ref = data || {};
	
	    var UserPoolId = _ref.UserPoolId;
	    var ClientId = _ref.ClientId;
	    var Paranoia = _ref.Paranoia;
	
	    if (!UserPoolId || !ClientId) {
	      throw new Error('Both UserPoolId and ClientId are required.');
	    }
	    if (!/^[\w-]+_.+$/.test(UserPoolId)) {
	      throw new Error('Invalid UserPoolId format.');
	    }
	    var region = UserPoolId.split('_')[0];
	
	    this.userPoolId = UserPoolId;
	    this.clientId = ClientId;
	    this.paranoia = Paranoia || 0;
	
	    this.client = new _awsSdk.CognitoIdentityServiceProvider({ apiVersion: '2016-04-19', region: region });
	  }
	
	  /**
	   * @returns {string} the user pool id
	   */
	
	
	  _createClass(CognitoUserPool, [{
	    key: 'getUserPoolId',
	    value: function getUserPoolId() {
	      return this.userPoolId;
	    }
	
	    /**
	     * @returns {string} the client id
	     */
	
	  }, {
	    key: 'getClientId',
	    value: function getClientId() {
	      return this.clientId;
	    }
	
	    /**
	     * @returns {int} the paranoia level
	     */
	
	  }, {
	    key: 'getParanoia',
	    value: function getParanoia() {
	      return this.paranoia;
	    }
	
	    /**
	     * sets paranoia level
	     * @param {int} paranoia The new paranoia level.
	     * @returns {void}
	     */
	
	  }, {
	    key: 'setParanoia',
	    value: function setParanoia(paranoia) {
	      this.paranoia = paranoia;
	    }
	
	    /**
	     * @typedef {object} SignUpResult
	     * @property {CognitoUser} user New user.
	     * @property {bool} userConfirmed If the user is already confirmed.
	     */
	    /**
	     * method for signing up a user
	     * @param {string} username User's username.
	     * @param {string} password Plain-text initial password entered by user.
	     * @param {(AttributeArg[])=} userAttributes New user attributes.
	     * @param {(AttributeArg[])=} validationData Application metadata.
	     * @param {nodeCallback<SignUpResult>} callback Called on error or with the new user.
	     * @returns {void}
	     */
	
	  }, {
	    key: 'signUp',
	    value: function signUp(username, password, userAttributes, validationData, callback) {
	      var _this = this;
	
	      this.client.makeUnauthenticatedRequest('signUp', {
	        ClientId: this.clientId,
	        Username: username,
	        Password: password,
	        UserAttributes: userAttributes,
	        ValidationData: validationData
	      }, function (err, data) {
	        if (err) {
	          return callback(err, null);
	        }
	
	        var cognitoUser = {
	          Username: username,
	          Pool: _this
	        };
	
	        var returnData = {
	          user: new _CognitoUser2.default(cognitoUser),
	          userConfirmed: data.UserConfirmed
	        };
	
	        return callback(null, returnData);
	      });
	    }
	
	    /**
	     * method for getting the current user of the application from the local storage
	     *
	     * @returns {CognitoUser} the user retrieved from storage
	     */
	
	  }, {
	    key: 'getCurrentUser',
	    value: function getCurrentUser() {
	      var lastUserKey = 'CognitoIdentityServiceProvider.' + this.clientId + '.LastAuthUser';
	      var storage = window.localStorage;
	
	      var lastAuthUser = storage.getItem(lastUserKey);
	      if (lastAuthUser) {
	        var cognitoUser = {
	          Username: lastAuthUser,
	          Pool: this
	        };
	
	        return new _CognitoUser2.default(cognitoUser);
	      }
	
	      return null;
	    }
	  }]);
	
	  return CognitoUserPool;
	}();
	
	exports.default = CognitoUserPool;

/***/ },
/* 14 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _AuthenticationDetails = __webpack_require__(12);
	
	Object.defineProperty(exports, 'AuthenticationDetails', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_AuthenticationDetails).default;
	  }
	});
	
	var _AuthenticationHelper = __webpack_require__(2);
	
	Object.defineProperty(exports, 'AuthenticationHelper', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_AuthenticationHelper).default;
	  }
	});
	
	var _CognitoAccessToken = __webpack_require__(3);
	
	Object.defineProperty(exports, 'CognitoAccessToken', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_CognitoAccessToken).default;
	  }
	});
	
	var _CognitoIdToken = __webpack_require__(4);
	
	Object.defineProperty(exports, 'CognitoIdToken', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_CognitoIdToken).default;
	  }
	});
	
	var _CognitoRefreshToken = __webpack_require__(5);
	
	Object.defineProperty(exports, 'CognitoRefreshToken', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_CognitoRefreshToken).default;
	  }
	});
	
	var _CognitoUser = __webpack_require__(6);
	
	Object.defineProperty(exports, 'CognitoUser', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_CognitoUser).default;
	  }
	});
	
	var _CognitoUserAttribute = __webpack_require__(7);
	
	Object.defineProperty(exports, 'CognitoUserAttribute', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_CognitoUserAttribute).default;
	  }
	});
	
	var _CognitoUserPool = __webpack_require__(13);
	
	Object.defineProperty(exports, 'CognitoUserPool', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_CognitoUserPool).default;
	  }
	});
	
	var _CognitoUserSession = __webpack_require__(8);
	
	Object.defineProperty(exports, 'CognitoUserSession', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_CognitoUserSession).default;
	  }
	});
	
	var _DateHelper = __webpack_require__(9);
	
	Object.defineProperty(exports, 'DateHelper', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_DateHelper).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }
/******/ ])
});
;


/** WEBPACK FOOTER **
 ** amazon-cognito-identity.min.js
 **/